import { supportCenterWsocket } from "WEBSOCKET/wsocket";

import { socketMessage } from "WEBSOCKET/constants";

import socketWorker from 'worker-loader!../socket.worker.js';
var worker;

export const initSocketWorker = () => {
  console.log("In initSocketWorker for SupportCenter");
  worker = new socketWorker();
}

export const connectWebsocket = (
  socketAddress,
  token,
  handleMessageCallback,
  handleDisconnectCallback,
  handleConnectErrorCallback,
  handleWebWorkerErrorCallback,
) => {
  console.log("In connectWebsocket for SupportCenter");

  var messageToPost = {
    action: "connect",
    payload: {
      socketAddress: socketAddress,
      token: token
    }
  }
  worker && worker.postMessage(JSON.stringify(messageToPost));
  //console.log("Posted message to worker");
  worker && worker.addEventListener("message", msg => {
    //console.log('Message from worker, msg:', msg);
    switch (msg.data.id) {
      case "connected":
        // console.log("Connected to socket server");
        supportCenterWsocket.io = true;
        break;
      case "message":
        handleMessageCallback(msg.data.payload);
        break;
      case "error":
        let data = {
          data: {
            category: socketMessage.category.ERROR,
            errorType: msg.data.data.type,
          }
        };
        handleMessageCallback(data);
        break;
      case "disconnect":
        handleDisconnectCallback(msg.data.payload);
        break;
      case "connect_error":
        handleConnectErrorCallback(msg.data.payload);
        break;
      default:
        console.warn("Invalid message id from worker:", msg.data.id);
    }
  });
  worker && worker.addEventListener("error", err => {
    // console.log("worker error", err)
    handleWebWorkerErrorCallback();
  });
};

export const disconnectWebsocket = () => {
  console.log("In disconnectWebsocket for SupportCenter");
  return function (dispatch, getState) {
    var messageToPost = {
      action: "disconnect"
    }
    worker && worker.postMessage(JSON.stringify(messageToPost));
    supportCenterWsocket.io = false;
  };
};

export const sendWebsocketMessage = (type, data) => {
  return function (dispatch, getState) {
    var messageToPost = {
      action: "emitMessage",
      payload: {
        type: type,
        data: data
      }
    }
    console.log('support center messageToPost: ', messageToPost);
    // initSocketWorker();
    worker && worker.postMessage(JSON.stringify(messageToPost));
  };
};
